


























import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { isPostKindOffer, isValidVipInServicelist } from "@/utils/general_utils";
import RecommendUtil from "@/utils/recommend_util/recommend_util";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
import { isFollow } from "@/services/offer/offer_handle";
@Component({
  components: { ImgFetched }
})
export default class VipContent extends Vue {
  private contentList: any = [
    {
      leftIcon: require("@/assets/icons-file/coins/lh_store_vip_follower.png"),
      content: "+10 bonus followers every day",
      rightText: "x30"
    },
    {
      leftIcon: require("@/assets/icons-file/coins/lh_store_vip_order.png"),
      content: "10% more on All 👤 ❤️ orders",
      rightIcon: require("@/assets/icons-file/coins/lh_store_vip_ok.png")
    },
    {
      leftIcon: require("@/assets/icons-file/coins/lh_store_vip_packs.png"),
      content: "Super big discount coins packs",
      rightText: "x4"
    },
    {
      leftIcon: require("@/assets/icons-file/coins/lh_store_vip_drop.png"),
      content: "No followers drop guaranteed",
      rightIcon: require("@/assets/icons-file/coins/lh_store_vip_ok.png")
    },
    {
      leftIcon: require("@/assets/icons-file/coins/lh_store_vip_active.png"),
      content: "More active & real followers",
      rightIcon: require("@/assets/icons-file/coins/lh_store_vip_ok.png")
    },
    {
      leftIcon: require("@/assets/icons-file/coins/lh_store_vip_speed.png"),
      content: "300% higher-speed growth",
      rightIcon: require("@/assets/icons-file/coins/lh_store_vip_ok.png")
    },

    {
      leftIcon: require("@/assets/icons-file/coins/lh_store_vip_personal.png"),
      content: "24/7 personal consultant",
      rightIcon: require("@/assets/icons-file/coins/lh_store_vip_ok.png")
    },
    {
      leftIcon: require("@/assets/icons-file/coins/lh_store_vip_ads.png"),
      content: "Remove ADS",
      rightIcon: require("@/assets/icons-file/coins/lh_store_vip_ok.png")
    }
  ];
  private recommendArr: any[] = [
    // {
    //   leftIcon: require("@/assets/icons-file/store_vip/lh_store_vip_view.png"),
    //   content: "See who viewed my profile",
    //   rightIcon: require("@/assets/icons-file/store_vip/lh_store_vip_ok.png")
    // },
    // {
    //   leftIcon: require("@/assets/icons-file/store_vip/lh_store_vip_secret.png"),
    //   content: "Find out secret admirers",
    //   rightIcon: require("@/assets/icons-file/store_vip/lh_store_vip_ok.png")
    // },
    // {
    //   leftIcon: require("@/assets/icons-file/store_vip/lh_store_vip_analytics.png"),
    //   content: "Followers & posts analytics",
    //   rightIcon: require("@/assets/icons-file/store_vip/lh_store_vip_ok.png")
    // }
  ];
  private renderList: any = [];

  get placeHolder() {
    return require("@/assets/icons-file/order/order_follow_placeholder.png")
  }

  private async getRenderList() {
    const vipServersList = isValidVipInServicelist();
    console.log("vipServersList", vipServersList);
    if (vipServersList) {
      this.renderList = [
        {
          leftIcon: vipServersList.resource.profile_pic_url,
          content: "+10 bonus followers every day",
          rightText: "x30",
          name: vipServersList.resource.username,
          type: "user_icon"
        },
        ...this.contentList.slice(1)
      ];
    } else {
      this.renderList = this.contentList;
    }
    // 加入判断，如果推荐app为空，才插入部分条目
    const recommendList = await RecommendUtil.getRecommendList();
    if (recommendList.length > 0) {
      this.renderList.splice(7, 0, ...this.recommendArr);
    }
  }
  private activated() {
    this.getRenderList();
  }
}
